import { render, staticRenderFns } from "./ForumResponseActionsButton.vue?vue&type=template&id=032b3d22&scoped=true"
import script from "./ForumResponseActionsButton.vue?vue&type=script&lang=js"
export * from "./ForumResponseActionsButton.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseActionsButton.vue?vue&type=style&index=0&id=032b3d22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b3d22",
  null
  
)

export default component.exports